export const OPEN_REPAIR_ORDERS_FETCH_REQUEST = 'OPEN_REPAIR_ORDERS_FETCH_REQUEST';
export const OPEN_REPAIR_ORDERS_FETCH_SUCCESS = 'OPEN_REPAIR_ORDERS_FETCH_SUCCESS';
export const OPEN_REPAIR_ORDERS_FETCH_FAILURE = 'OPEN_REPAIR_ORDERS_FETCH_FAILURE';
